import "../Styles/section.css";
import React, { useContext } from "react";
import { TeamContext } from "../Contexts/TeamContext";
import Loading from "../pages/Loading";

const OurStory = () => {
  const { team, loading } = useContext(TeamContext);

  return (
    <>
      <div className="ourStory">
        <h2 data-aos="fade-right" data-aos-duration="1000">
          Our Story
        </h2>
      </div>
      <div className="myFlex">
        <div className="left" data-aos="fade-right" data-aos-duration="1000">
          <h3>
            The Wild <br /> Inspiration
          </h3>
          <p>
            Growing up amidst the breathtaking views of Musanze,  with its
            towering volcanoes, Rigobert developed a profound love for animals
            that fueled his artistic passion.  Recognizing the challenges faced
            by young African artists, particularly the high unemployment rates
            and limited opportunities in Africa,  Rigobert established SAWA to
            provide a platform for emerging talent. Founded in
            Musanze, Rwanda, in 2023,  the studio aims to foster a community of
            artists where they can express themselves freely,  connect with
            peers, and explore their potential while deepening their
            understanding of wildlife.
          </p>
        </div>
        <div className="right" data-aos="fade-left" data-aos-duration="1000">
          <div className="Dark">
            {/* Image goes inside here */}
            <img
              src="https://res.cloudinary.com/duchitv8b/image/upload/w_auto,q_auto,f_auto/c_limit,w_1500/v1twjucja0qwljb0kdzk.webp"
              alt=""
            />
          </div>
        </div>
      </div>
      <div className="clip-full">
        <h4 data-aos="fade-down" data-aos-duration="400">
          Our Impact
        </h4>
        <h2 data-aos="fade-up" data-aos-duration="400">
          Conservation <br /> Through <br /> WildlifeArt
        </h2>
        <div className="text">
          <div className="inner" data-aos="fade-in" data-aos-duration="1000">
            <p>
              At SAWA, we believe art has the extraordinary ability to inspire,
              educate and ignite change. That's why we created TUZIVUGIRE 
            </p>
            {/* Icon is needed here */}
            <a href="/conservation">
            <button
              className="custom-button-white"
              data-aos="fade-in"
              data-aos-duration="1000"
            >
              View More <span className="ml-2 mt-1 font-bold">{">"}</span>
            </button>
            </a>
          </div>
        </div>
      </div>
      <div className="ourStory2 textReverse">
        <h2 data-aos="fade-down" data-aos-duration="600">
          Our Mission
        </h2>
      </div>
      <div className="myFlex FlexReverse">
        <div className="left" data-aos="fade-down" data-aos-duration="1000">
          <h3>Building Artists, Saving Species</h3>
          <p>
            We are incredibly fortunate to share our planet with such
            magnificent creatures.  Through our art, we aim to foster a deeper
            connection between humans and wildlife by meticulously capturing the
            emotions and expressions of these animals.  Our mission is to create
            a community of artists who will inspire a passion for wildlife
            conservation through their work.
          </p>
        </div>
        <div className="right" data-aos="fade-down" data-aos-duration="600">
          <div className="Light">
            {/* Image goes inside here */}
            <img
              src="https://res.cloudinary.com/duchitv8b/image/upload/w_auto,q_auto,f_auto/c_limit,w_1500/bmqj5vcska9n5iwmsfhq.webp"
              alt=""
            />
          </div>
        </div>
      </div>
      {/* Redisigning for Image to fit teh image box */}
      <div className="Team">
        <h1 data-aos="fade-in" data-aos-duration="600">
          Meet The Team
        </h1>
        {loading ? (
          <Loading /> // Display the Loading component while loading is true
        ) : (
          <div className="cards">
            {team.map((member) => (
              <div
                className="card"
                key={member._id}
                data-aos="fade-in"
                data-aos-duration="1000"
              >
                <img
                  src={`${member.image}`}
                  alt={`${member.name} profile`}
                />
                <h2>{member.name}</h2>
                <p>{member.position}</p>
              </div>
            ))}
          </div>
        )}
      </div>
      {/* <div className="bookNow">
                <h2 data-aos="fade-down" data-aos-duration="600">Let's Paint Together</h2>
                <p data-aos="fade-up" data-aos-duration="600">
                    Services Lorem ipsum dolor sit amet consectetur.
                    Commodo vulputate malesuada lectus phasellus at turpis ac.
                    Aenean etiam in volutpat risus eu metus eros turpis. Quis sit
                    nulla augue velit. Lorem ipsum dolor sit amet consectetur. Commodo
                    vulputate malesuada lectus phasellus at turpis ac. Aenean etiam in
                    volutpat risus eu metus eros turpis. Quis sit nulla augue velit.
                </p>
                <button data-aos="fade-down" data-aos-duration="600">Book Now </button>
            </div> */}
    </>
  );
};

export default OurStory;
